export class NineAi extends HTMLElement
{
	#ing = false;
	#ai;

	settings;
	config;

	static context = "";
	static cssPath = "";
	static promptPath = "";

	static {
		// 1. 이름표 달기
		trace.init("nine-ai", "green");
	}


}

if (!customElements.get("nine-ai")) {
	customElements.define("nine-ai", NineAi);
}

